import React from 'react';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-redux-form';
import CustomInput from '../../custom-input/custom-input';

interface TimeModalFormProps {
    dayNumber: number,
}
const TimeModalForm: React.FC<TimeModalFormProps> = (props) => {

    const { t } = useTranslation()
    return (
        <div className='d-flex justify-content-around w-100'>
            <div className='default-field'>
                <Control
                    model='.tmpTime.from'
                    component={CustomInput}
                    defaultValue='00'
                    label={t('startTime')}
                    mapProps={{
                        helperText: () => t('time.hoursOnly')
                    }}
                    id='.tmpTime.from' />
            </div>
            <div className='default-field'>
                <Control
                    model='.tmpTime.to'
                    component={CustomInput}
                    defaultValue='00'
                    label={t('endTime')}
                    mapProps={{
                        helperText: () => t('time.hoursOnly')
                    }}
                    id='.tmpTime.to' />
            </div>
        </div>
    )
}

export default TimeModalForm;